module.exports = __webpack_public_path__ + "img/default-mobile-english-no-content.ba296f2c.png";